import React, { useState } from "react";
import { useScrolled } from "./Hooks";
import { MenuIcon, CloseIcon } from "./Icons";
import {
  NavWrapper,
  NavLogoLink,
  NavLinks,
  NavLink,
  NavCta,
  HamburgerBtn,
  MobileMenu,
  MobileNavLink,
  MobileNavCta,
  LogoContainer,
} from "../Styles";
import { CompanyLogo } from "../../../../styles/component/style";
import { Images } from "../../../../assets/images";
import useWebinar from "../../../../hooks/useWebinar";

function Navbar() {
  const scrolled = useScrolled(40);
  const [mobileOpen, setMobileOpen] = useState(false);
  const closeMobileMenu = () => setMobileOpen(false);
  const toggleMobileMenu = () => setMobileOpen((prev) => !prev);

  const { config } = useWebinar();
  const navConfig = config?.navbar;

  const visibleLinks = navConfig?.links?.filter((link) => link?.show) ?? [];

  return (
    <>
      <NavWrapper $scrolled={scrolled}>
        <NavLogoLink href="#">
          <LogoContainer>
            <CompanyLogo src={Images.companyLogo} alt="IAMC logo" />
          </LogoContainer>
        </NavLogoLink>
        <NavLinks>
          {visibleLinks.map((link) => (
            <NavLink key={link.href} href={link.href}>
              {link.label}
            </NavLink>
          ))}
          {navConfig?.ctaHref && (
            <NavCta href={navConfig.ctaHref}>{navConfig.ctaLabel}</NavCta>
          )}
        </NavLinks>
        <HamburgerBtn
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          onClick={toggleMobileMenu}
        >
          {mobileOpen ? <CloseIcon /> : <MenuIcon />}
        </HamburgerBtn>
      </NavWrapper>
      {mobileOpen && (
        <MobileMenu>
          {visibleLinks.map((link) => (
            <MobileNavLink
              key={link.href}
              href={link.href}
              onClick={closeMobileMenu}
            >
              {link.label}
            </MobileNavLink>
          ))}
          {navConfig?.ctaHref && (
            <MobileNavCta href={navConfig.ctaHref} onClick={closeMobileMenu}>
              {navConfig.ctaLabel}
            </MobileNavCta>
          )}
        </MobileMenu>
      )}
    </>
  );
}

export { Navbar };
